<template>
    <div class="input_box flexbox">
        <!-- 单元格页面 -->
        <div class="codes">
            <!-- 通过长度与获取焦点标签控制单元格是否高亮 -->
            <div class="code_item" :class="codeValue.length == 0 && inputFocus ? 'code_item_active' : ''">
                {{ formatVal(codeValue[0]) }}
            </div>
            <div class="code_item" :class="codeValue.length == 1 && inputFocus ? 'code_item_active' : ''">
                {{ formatVal(codeValue[1]) }}
            </div>
            <div class="code_item" :class="codeValue.length == 2 && inputFocus ? 'code_item_active' : ''">
                {{ formatVal(codeValue[2]) }}
            </div>
            <div class="code_item" :class="codeValue.length == 3 && inputFocus ? 'code_item_active' : ''" style="margin-right:0">
                {{ formatVal(codeValue[3]) }}
            </div>
        </div>
        <!-- input框：控制长度 -->
        <Input class="input_code" v-model="codeValue" :maxlength="4" autofocus 
            @on-blur="codeInputBlur" @on-focus="codeInputFocus"
            @on-change="codeInputChange">
        </Input>
    </div>
</template>

<script>
export default {
    data() {
        return {
            inputFocus: false,
            codeValue: '',
            title: '密码输入'
        }
    },
    props: {
    },
    methods: {
        init() {
            this.codeValue = ''
        },
        // 校验输入的验证码/密码
        getCodeValue() {
            return this.codeValue
        },
        // 验证码输入框
        codeInputChange(e) {
            // 判断是否输入值
            if (e) {
                // 正则判断是否都是数字，如果都是数字则赋值,否则
                if ((/^\+?[0-9][a-z][A-Z]*$/).test(e)) {
                    this.codeValue = e
                }
            } else {
                this.codeValue = ''
            }
        },
        // 验证码输入框失去焦点
        codeInputBlur() {
            this.inputFocus = false
        },
        // 验证码输入框获取到焦点
        codeInputFocus() {
            this.inputFocus = true
        },
        formatVal(val){
            if(!val) return '';
            return '*'
        }
    }
}
</script>

<style lang="scss">
// 隐藏input
.input_box .ivu-input-default {
    width: 100%;
    height: 50px !important;
    background-color: transparent;
    border: none;
    color: transparent;
}
</style>

<style lang="scss" scoped>
.input_box {
    margin: 0px;
    height: 50px;
    position: relative;
}

.input_code {
    position: absolute;
    top: 0;
    left: 0;
}
.codes {
    position: absolute;
    top: 0;
    display: flex;
    justify-content: flex-start;
    .code_item {
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border: 1px solid #f0f0f0;
        margin-right: 50px;
        background: #f8f9f8;
        font-size:20px; font-weight: bold;
    }
    .code_item:last-child{
        margin-right: 0px;
    }
}

.code_item_active {
    border: 1px solid #da7503 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/wcn/inputPwd.vue